import React, { type ReactNode } from "react";

import WrapExperienceAuthor from "./WrapExperienceAuthor";
import WrapExperienceButton from "./WrapExperienceButton";
import WrapExperienceCardContext, {
  type WrapExperienceCardProps,
} from "./WrapExperienceContext";
import WrapExperienceImage from "./WrapExperienceImage";
import WrapExperienceProfile from "./WrapExperienceProfile";
import WrapExperienceText from "./WrapExperienceText";
import WrapExperienceTextTitle from "./WrapExperienceTextTitle";
import WrapExperienceTitle from "./WrapExperienceTitle";

interface Props {
  card: WrapExperienceCardProps;
  image?: ReactNode;
  profile?: ReactNode;
  info?: ReactNode;
  action?: ReactNode;
  topRight?: ReactNode;
  modals?: ReactNode;
}

const WrapExperienceCard = ({
  card,
  image,
  info,
  action,
  profile,
  topRight,
  modals,
}: Props) => {
  const hideFooter = profile || info || action ? "" : "hidden";
  return (
    <WrapExperienceCardContext.Provider value={{ card }}>
      <div className="relative flex justify-center overflow-visible">
        {modals}
        <div className="absolute right-6 top-6 z-20">{topRight}</div>
        <div className="aspect-9/16 group flex max-h-[70vh] w-full flex-col  overflow-hidden rounded-2xl bg-white shadow-md">
          {image}

          <div
            className={`${hideFooter} relative bottom-0 space-y-2 whitespace-nowrap bg-white px-2 py-2 md:px-4 md:py-4`}
          >
            <div className="flex h-10 grow space-x-1 md:space-x-4">
              {profile}
              <div className="flex flex-col"> {info}</div>
            </div>
            <div className="w-full">{action}</div>
          </div>
        </div>
      </div>
    </WrapExperienceCardContext.Provider>
  );
};

WrapExperienceCard.Image = WrapExperienceImage;
WrapExperienceCard.Title = WrapExperienceTitle;
WrapExperienceCard.Author = WrapExperienceAuthor;
WrapExperienceCard.Profile = WrapExperienceProfile;
WrapExperienceCard.Button = WrapExperienceButton;
WrapExperienceCard.Text = WrapExperienceText;
WrapExperienceCard.TextTitle = WrapExperienceTextTitle;
export default WrapExperienceCard;
